import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import {
  fetchShipmentDashBoardDetailsSuccess,
  fetchShipmentDashBoardDetailsFailure,
} from './actions';

import axiosConfig from './axiosConfig';
import { FETCH_SHIPMENTS_DETAILS } from './types';

function* fetchShipmentTypeDetails(payload) {
  try {
    let url;

    if (payload.pageNumber && payload.pageSize && payload.searchKey) {
      url = `/shipments?projectId=${payload.projectId}&searchKey=${payload.searchKey}&pageSize=${payload.pageSize}&pageNumber=${payload.pageNumber}`;
    } else if (payload.pageNumber && payload.pageSize) {
      url = `/shipments?projectId=${payload.projectId}&pageSize=${payload.pageSize}&pageNumber=${payload.pageNumber}`;
    } else if (payload.searchKey) {
      url = `/shipments?projectId=${payload.projectId}&searchKey=${payload.searchKey}`;
    } else {
      url = `/shipments?projectId=${payload.projectId}`;
    }

    const res = yield axiosConfig.get(url);
    const response = get(res, ['data', 'data'], {});
    // notification.destroy();
    if (res.status === 200) {
      yield put(fetchShipmentDashBoardDetailsSuccess({ response }));
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchShipmentDashBoardDetailsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Shipment details.',
      description: `${error}`,
    });
  }
}

function* shipmentDashBoardWatcher() {
  yield takeLatest(FETCH_SHIPMENTS_DETAILS, fetchShipmentTypeDetails);
}

function* shipmentDashBoardSagas() {
  yield all([call(shipmentDashBoardWatcher)]);
}

export default shipmentDashBoardSagas;

export const OnAddorUpdateShipmentsDashboard = async (payload, isEdit) => {
  try {
    let res = '';
    if (isEdit) {
      res = await axiosConfig.put(`/shipments/${encodeURIComponent(payload.id)}`, payload.data);
    } else res = await axiosConfig.post(`/shipments?projectId=${payload.projectId}`, payload);

    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      if (response == 'Shipment Type already exists.!') {
        // notification.warning({
        //   message: 'Shipment type  and number already exists.!'
        // });
        return null;
      }

      notification.success({
        message: isEdit
          ? 'Shipment type updated successfully.'
          : 'Shipment type added successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

export const OnDeleteShipments = async (payload) => {
  try {
    console.log(payload);
    const res = await axiosConfig.delete(`/shipments/${payload.pihShipmentId}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: 'Shipment type deleted successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

export const OnAddorUpdateShipmentNumber = async (payload, isEdit) => {
  try {
    console.log(payload);
    let res = '';
    if (isEdit) {
      res = await axiosConfig.put(`shipments/${encodeURIComponent(payload.id)}`, payload.data);
    } else res = await axiosConfig.post(`/shipments`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: isEdit
          ? 'Shipment number updated successfully.'
          : 'Shipment number added successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

export const OnDeleteShipmentNumber = async (payload) => {
  try {
    console.log(payload);
    const res = await axiosConfig.delete(`/shipments/${payload.id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: 'Shipment number deleted successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

/** Get all listed equipment types*/
export const OnFetchShipmentSno = async (payload) => {
  try {
    var res;

    res = await axiosConfig.get(`/shipment-type/${payload.id}`);

    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      return response;
    } else {
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
      return null;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Equipments.',
      description: `${error.error}`,
    });
    return null;
  }
};

export const OnGetShippingForm = async (submissionId) => {
  try {
    var res;
    res = await axiosConfig.get(`/shipping-forms?submissionId=${encodeURIComponent(submissionId)}`);
    const response = get(res, ['data', 'data'], {});

    if (res.status === 200) {
      return response;
    } else {
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
      return null;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Equipments.',
      description: `${error.error}`,
    });
    return null;
  }
};
